import jQuery from 'jquery'; // Import directly from node-modules
window.jQuery = jQuery;

export default () => jQuery;
